import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { formatDate } from 'bookingform';
import BookingSummaryItem from './BookingSummaryItem';

const getNights = (dates) => {
  const init = moment(dates.checkIn);
  const end = moment(dates.checkOut);
  return end.diff(init, 'days');
};

const getDate = (dates, lang, chain) => (
  `${formatDate(dates.checkIn, lang, chain)} - ${formatDate(dates.checkOut, lang, chain)}`);

const items = ({
  hotel, dates, distribution, lang, chain,
}, context) => {
  let adults = 0;
  let children = 0;
  let infants = 0;
  if (distribution) {
    if (Array.isArray(distribution)) {
      distribution.forEach((d) => {
        adults += d.adl;
        children += d.chd;
        infants += d.enf;
      });
    } else {
      adults = distribution.adl;
      children = distribution.chd;
      infants = distribution.enf;
    }
  }

  let title = context.t(['1 Adult', '{n} Adults'], { n: adults });
  if (children && children > 0) {
    title = `${context.t(['1 Adult', '{n} Adults'], { n: adults })} + ${
      context.t(['1 Child', '{n} Children'], { n: children })}`;
  }
  if (infants && infants > 0) {
    title = `${context.t(['1 Adult', '{n} Adults'], { n: adults })} + ${
      context.t(['1 Child', '{n} Children'], { n: children })} + ${
      context.t(['1 Infant', '{n} Infants'], { n: infants })}`;
  }
  if (adults + children + infants > 0) {
    return [
      {
        title: hotel.name || hotel,
        icon: 'map',
        id: '1',
      },
      {
        title: getDate(dates, lang, chain),
        subtitle: context.t(['1 night', '{n} nights'], { n: getNights(dates) }),
        icon: 'calendar',
        id: '2',
      },
      {
        title,
        icon: 'user',
        id: '3',
      },
    ];
  }
  return [
    {
      title: hotel.name || hotel,
      icon: 'map',
      id: '1',
    },
    {
      title: getDate(dates, lang, chain),
      subtitle: context.t(['1 night', '{n} nights'], { n: getNights(dates) }),
      icon: 'calendar',
      id: '2',
    },
  ];
};

const RowSummary = (props, context) => {
  const { className, children, onClick } = props;
  return (
    <div className={`flex flex-wrap -mx-2 | ${className || ''} ${onClick ? 'cursor-pointer' : ''}`} onClick={onClick}>
      { items(props, context).map(({
        title, icon, subtitle, id,
      }) => (
        title && <BookingSummaryItem icon={icon} title={title} subtitle={subtitle} className="m-2" key={id}/>
      ))}
      {children}
    </div>
  );
};

RowSummary.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  hotel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  dates: PropTypes.object.isRequired,
};

RowSummary.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default RowSummary;
